import React from 'react';

import { Icon } from '../styles';

export enum IconTypes {
  Airplane,
  PaperAirplane,
  Car,
}

interface Props {
  type: IconTypes;
}

const Icons = {
  [IconTypes.Airplane]: 'success-plane.svg',
  [IconTypes.PaperAirplane]: 'success-paper-plane.svg',
  [IconTypes.Car]: 'autos/icon-car.svg',
};

const InfoIcon = ({ type }: Props) => <Icon type={type} src={`/corporate/images/${Icons[type]}`} />;

export default InfoIcon;
